import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography
} from '@one-thd/sui-atomic-components';
import { func, bool, string } from 'prop-types';
import _noop from 'lodash/noop';

const DEFAULT_MODAL_BODY_TEXT = 'Starting over will erase all progress on the current stack.';

const ConfirmRestartModal = ({
  isOpen,
  setIsOpen,
  handleReset,
  modalBodyText = DEFAULT_MODAL_BODY_TEXT,
}) => {
  const handleClose = () => setIsOpen(false);

  return (
    <Modal size="sm" open={isOpen} onClose={handleClose}>
      <ModalHeader onClose={handleClose}>Start Over?</ModalHeader>
      <ModalBody>
        <Typography variant="body-base">
          <div>{`${modalBodyText} Are you sure you want to start over?`}</div>
        </Typography>
      </ModalBody>
      <ModalFooter position="center">
        <div className="sui-mr-2 sui-w-full">
          <Button fullWidth onClick={handleClose} variant="secondary">Cancel</Button>
        </div>
        <div className="sui-ml-2 sui-w-full">
          <Button fullWidth onClick={handleReset} variant="primary">Start Over</Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

ConfirmRestartModal.propTypes = {
  isOpen: bool,
  setIsOpen: func,
  handleReset: func,
  modalBodyText: string.isRequired,
};

ConfirmRestartModal.defaultProps = {
  isOpen: false,
  setIsOpen: _noop,
  handleReset: _noop,
};

export default ConfirmRestartModal;
